module.exports = __webpack_public_path__ + "img/shopify.f4212e93.png";